"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaffTypeCode = void 0;
var StaffTypeCode;
(function (StaffTypeCode) {
    StaffTypeCode["CareerService"] = "Career Service";
    StaffTypeCode["ConsultantStaff"] = "Consultant Staff";
    StaffTypeCode["ExternalConsultant"] = "External Consultant";
    StaffTypeCode["OpsStaff"] = "Other Personal Services (OPS) Staff";
    StaffTypeCode["OutsideAgency"] = "Outside Agency";
    StaffTypeCode["SesManager"] = "Select Exempt Service";
    StaffTypeCode["SmsManager"] = "Senior Management Service";
})(StaffTypeCode = exports.StaffTypeCode || (exports.StaffTypeCode = {}));
